import { SceneComponent } from 'src/sdk-components/SceneComponent';

export class ThreeInstance extends SceneComponent {
  public get() {
    return this.context.three;
  }
}

export const threeInstanceComponentType = 'mp.threeInstance';
export const makeThreeInstance = () => new ThreeInstance();
